import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'agreement-non-main-devices-warning',
    templateUrl: './agreement-non-main-devices-warning.component.html',
    styleUrls: ['./agreement-non-main-devices-warning.component.scss']
})
export class AgreementNonMainDevicesWarningComponent {

    @Input() items: string[] = [];

    @Output() onCancelEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() onConfirmEvent: EventEmitter<void> = new EventEmitter<void>();

    cancel() {
        this.onCancelEvent.emit();
    }

    confirm() {
        this.onConfirmEvent.emit();
    }
}
